// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/PricingModal.css */
.pricing-section {
    padding: 6rem 1rem;
    background: #f8fafc;
    text-align: center;
  }
  
  .pricing-container {
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .pricing-intro h2 {
    font-size: 2.5rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 1rem;
  }
  
  .pricing-intro p {
    font-size: 1.2rem;
    color: #64748b;
    margin-bottom: 2rem;
  }
  
  .view-pricing-button {
    background: linear-gradient(to right, #2563eb, #4f46e5);
    color: white;
    font-weight: 600;
    font-size: 1.1rem;
    padding: 0.8rem 1.5rem;
    border: none;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .view-pricing-button:hover {
    background: linear-gradient(to right, #1d4ed8, #4338ca);
    transform: translateY(-2px);
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
  }
  
  .pricing-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  
  .modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }
  
  .modal-content {
    background: white;
    border-radius: 16px;
    padding: 2rem;
    width: 90%;
    max-width: 1200px;
    position: relative;
    z-index: 1001;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
    max-height: 90vh;
    overflow-y: auto;
  }
  
  .modal-header {
    text-align: center;
    margin-bottom: 2rem;
    position: relative;
  }
  
  .modal-header h2 {
    font-size: 2rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 0.5rem;
  }
  
  .modal-header p {
    font-size: 1.1rem;
    color: #64748b;
    margin-bottom: 1rem;
  }
  
  .close-button {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    background: none;
    border: none;
    font-size: 1.8rem;
    cursor: pointer;
    color: #64748b;
    transition: color 0.2s;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
  }
  
  .close-button:hover {
    background: #f1f5f9;
    color: #1e293b;
  }
  
  .pricing-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1.5rem;
  }
  
  .pricing-card {
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    position: relative;
    transition: transform 0.3s ease;
    border: 1px solid #e2e8f0;
    display: flex;
    flex-direction: column;
  }
  
  .pricing-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
  }
  
  .pricing-card.popular {
    border: 2px solid #2563eb;
    transform: scale(1.02);
  }
  
  .popular-badge {
    position: absolute;
    top: -12px;
    right: 20px;
    background: #2563eb;
    color: white;
    font-weight: 600;
    padding: 0.25rem 1rem;
    border-radius: 20px;
    font-size: 0.9rem;
  }
  
  .pricing-card h3 {
    font-size: 1.5rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 1rem;
  }
  
  .price {
    font-size: 1.5rem;
    font-weight: 800;
    color: #2563eb;
    margin-bottom: 0.5rem;
  }
  
  .yearly {
    font-size: 1rem;
    font-weight: 600;
    color: #64748b;
    margin-top: 0.25rem;
  }
  
  .ideal-for {
    font-size: 1rem;
    color: #475569;
    margin-bottom: 1.5rem;
    font-style: italic;
    flex-grow: 1;
  }
  
  .features {
    text-align: left;
    margin: 1.5rem 0;
    padding-left: 1.5rem;
    flex-grow: 1;
  }
  
  .features li {
    margin-bottom: 0.8rem;
    color: #64748b;
    font-size: 0.95rem;
  }
  
  .cta-button {
    background: linear-gradient(to right, #2563eb, #4f46e5);
    color: white;
    font-weight: 600;
    font-size: 1rem;
    padding: 0.8rem 1.5rem;
    border: none;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-top: auto;
  }
  
  .cta-button:hover {
    background: linear-gradient(to right, #1d4ed8, #4338ca);
    transform: translateY(-2px);
  }
  
  /* Mobile Responsiveness */
  @media (max-width: 768px) {
    .pricing-section {
      padding: 4rem 1rem;
    }
    
    .pricing-intro h2 {
      font-size: 2rem;
    }
    
    .pricing-intro p {
      font-size: 1.1rem;
    }
    
    .modal-content {
      padding: 1.5rem;
    }
    
    .modal-header h2 {
      font-size: 1.5rem;
    }
    
    .modal-header p {
      font-size: 1rem;
    }
    
    .pricing-grid {
      grid-template-columns: 1fr;
      gap: 1rem;
    }
    
    .pricing-card {
      padding: 1.25rem;
    }
    
    .pricing-card.popular {
      transform: none;
    }
    
    .price {
      font-size: 1.4rem;
    }
    
    .yearly {
      font-size: 0.95rem;
    }
    
    .close-button {
      top: 0.25rem;
      right: 0.25rem;
      font-size: 1.5rem;
    }
  }
  
  @media (max-width: 480px) {
    .pricing-section {
      padding: 3rem 1rem;
    }
    
    .pricing-intro h2 {
      font-size: 1.8rem;
    }
    
    .view-pricing-button {
      font-size: 1rem;
      padding: 0.7rem 1.25rem;
    }
    
    .pricing-card h3 {
      font-size: 1.3rem;
    }
    
    .price {
      font-size: 1.3rem;
    }
    
    .features li {
      font-size: 0.9rem;
    }
    
    .cta-button {
      font-size: 0.95rem;
      padding: 0.7rem 1.25rem;
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/PricingSection.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,uDAAuD;IACvD,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,wCAAwC;EAC1C;;EAEA;IACE,uDAAuD;IACvD,2BAA2B;IAC3B,yCAAyC;EAC3C;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,+CAA+C;IAC/C,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,yCAAyC;IACzC,kBAAkB;IAClB,+BAA+B;IAC/B,yBAAyB;IACzB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,+CAA+C;EACjD;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,uDAAuD;IACvD,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,uDAAuD;IACvD,2BAA2B;EAC7B;;EAEA,0BAA0B;EAC1B;IACE;MACE,kBAAkB;IACpB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,0BAA0B;MAC1B,SAAS;IACX;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,YAAY;MACZ,cAAc;MACd,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,eAAe;MACf,uBAAuB;IACzB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,uBAAuB;IACzB;EACF","sourcesContent":["/* src/PricingModal.css */\n.pricing-section {\n    padding: 6rem 1rem;\n    background: #f8fafc;\n    text-align: center;\n  }\n  \n  .pricing-container {\n    max-width: 1200px;\n    margin: 0 auto;\n  }\n  \n  .pricing-intro h2 {\n    font-size: 2.5rem;\n    font-weight: 700;\n    color: #1e293b;\n    margin-bottom: 1rem;\n  }\n  \n  .pricing-intro p {\n    font-size: 1.2rem;\n    color: #64748b;\n    margin-bottom: 2rem;\n  }\n  \n  .view-pricing-button {\n    background: linear-gradient(to right, #2563eb, #4f46e5);\n    color: white;\n    font-weight: 600;\n    font-size: 1.1rem;\n    padding: 0.8rem 1.5rem;\n    border: none;\n    border-radius: 50px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  }\n  \n  .view-pricing-button:hover {\n    background: linear-gradient(to right, #1d4ed8, #4338ca);\n    transform: translateY(-2px);\n    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);\n  }\n  \n  .pricing-modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n  }\n  \n  .modal-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n  }\n  \n  .modal-content {\n    background: white;\n    border-radius: 16px;\n    padding: 2rem;\n    width: 90%;\n    max-width: 1200px;\n    position: relative;\n    z-index: 1001;\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);\n    max-height: 90vh;\n    overflow-y: auto;\n  }\n  \n  .modal-header {\n    text-align: center;\n    margin-bottom: 2rem;\n    position: relative;\n  }\n  \n  .modal-header h2 {\n    font-size: 2rem;\n    font-weight: 700;\n    color: #1e293b;\n    margin-bottom: 0.5rem;\n  }\n  \n  .modal-header p {\n    font-size: 1.1rem;\n    color: #64748b;\n    margin-bottom: 1rem;\n  }\n  \n  .close-button {\n    position: absolute;\n    top: 0.5rem;\n    right: 0.5rem;\n    background: none;\n    border: none;\n    font-size: 1.8rem;\n    cursor: pointer;\n    color: #64748b;\n    transition: color 0.2s;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n  }\n  \n  .close-button:hover {\n    background: #f1f5f9;\n    color: #1e293b;\n  }\n  \n  .pricing-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n    gap: 1.5rem;\n  }\n  \n  .pricing-card {\n    background: white;\n    border-radius: 16px;\n    padding: 1.5rem;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n    position: relative;\n    transition: transform 0.3s ease;\n    border: 1px solid #e2e8f0;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .pricing-card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);\n  }\n  \n  .pricing-card.popular {\n    border: 2px solid #2563eb;\n    transform: scale(1.02);\n  }\n  \n  .popular-badge {\n    position: absolute;\n    top: -12px;\n    right: 20px;\n    background: #2563eb;\n    color: white;\n    font-weight: 600;\n    padding: 0.25rem 1rem;\n    border-radius: 20px;\n    font-size: 0.9rem;\n  }\n  \n  .pricing-card h3 {\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: #1e293b;\n    margin-bottom: 1rem;\n  }\n  \n  .price {\n    font-size: 1.5rem;\n    font-weight: 800;\n    color: #2563eb;\n    margin-bottom: 0.5rem;\n  }\n  \n  .yearly {\n    font-size: 1rem;\n    font-weight: 600;\n    color: #64748b;\n    margin-top: 0.25rem;\n  }\n  \n  .ideal-for {\n    font-size: 1rem;\n    color: #475569;\n    margin-bottom: 1.5rem;\n    font-style: italic;\n    flex-grow: 1;\n  }\n  \n  .features {\n    text-align: left;\n    margin: 1.5rem 0;\n    padding-left: 1.5rem;\n    flex-grow: 1;\n  }\n  \n  .features li {\n    margin-bottom: 0.8rem;\n    color: #64748b;\n    font-size: 0.95rem;\n  }\n  \n  .cta-button {\n    background: linear-gradient(to right, #2563eb, #4f46e5);\n    color: white;\n    font-weight: 600;\n    font-size: 1rem;\n    padding: 0.8rem 1.5rem;\n    border: none;\n    border-radius: 50px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    margin-top: auto;\n  }\n  \n  .cta-button:hover {\n    background: linear-gradient(to right, #1d4ed8, #4338ca);\n    transform: translateY(-2px);\n  }\n  \n  /* Mobile Responsiveness */\n  @media (max-width: 768px) {\n    .pricing-section {\n      padding: 4rem 1rem;\n    }\n    \n    .pricing-intro h2 {\n      font-size: 2rem;\n    }\n    \n    .pricing-intro p {\n      font-size: 1.1rem;\n    }\n    \n    .modal-content {\n      padding: 1.5rem;\n    }\n    \n    .modal-header h2 {\n      font-size: 1.5rem;\n    }\n    \n    .modal-header p {\n      font-size: 1rem;\n    }\n    \n    .pricing-grid {\n      grid-template-columns: 1fr;\n      gap: 1rem;\n    }\n    \n    .pricing-card {\n      padding: 1.25rem;\n    }\n    \n    .pricing-card.popular {\n      transform: none;\n    }\n    \n    .price {\n      font-size: 1.4rem;\n    }\n    \n    .yearly {\n      font-size: 0.95rem;\n    }\n    \n    .close-button {\n      top: 0.25rem;\n      right: 0.25rem;\n      font-size: 1.5rem;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .pricing-section {\n      padding: 3rem 1rem;\n    }\n    \n    .pricing-intro h2 {\n      font-size: 1.8rem;\n    }\n    \n    .view-pricing-button {\n      font-size: 1rem;\n      padding: 0.7rem 1.25rem;\n    }\n    \n    .pricing-card h3 {\n      font-size: 1.3rem;\n    }\n    \n    .price {\n      font-size: 1.3rem;\n    }\n    \n    .features li {\n      font-size: 0.9rem;\n    }\n    \n    .cta-button {\n      font-size: 0.95rem;\n      padding: 0.7rem 1.25rem;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
